import React from 'react';
import { RotateCcw } from 'lucide-react';
import { CHAPTERS, END_CARD } from '../data/script';
type Props = {
  onReplay: () => void;
  onExplore: () => void;
  onChapter: (chapter: number) => void;
};
export function EndCard({
  onReplay,
  onExplore,
  onChapter
}: Props) {
  return <div className="absolute inset-0 z-40 flex items-center justify-center bg-[radial-gradient(ellipse_at_center,rgba(7,8,12,0.72)_0%,rgba(7,8,12,0.94)_75%)] px-6 backdrop-blur-[10px]" data-id="element-177" data-mp="3bydopgy11pgz">
      <div className="max-w-[560px] text-center animate-[fadeUp_0.6s_ease_both]" data-id="element-178" data-mp="3ky6djtoa6bp">
        <h2 className="text-[40px] font-semibold leading-[46px] tracking-[-0.03em] text-[#EDEEF2] max-sm:text-[30px] max-sm:leading-9" data-id="element-179" data-mp="8jrj3a14xtat">
          {END_CARD.title}
        </h2>
        <p className="mx-auto mt-3 max-w-[420px] text-[15px] leading-6 text-[#9A9FB0]" data-id="element-180" data-mp="3uvyfwuo9l04r">{END_CARD.line}</p>
        <div className="mt-7 flex flex-wrap items-center justify-center gap-2" data-id="element-181" data-mp="mfvaywojdpk4">
          <button type="button" onClick={onReplay} className="flex h-11 items-center gap-2 rounded-full bg-white px-5 text-[14px] font-semibold text-[#07080C] transition-transform duration-200 hover:scale-[1.03] active:scale-[0.98]" data-id="element-182" data-mp="r97uwti9t86j">
            <RotateCcw className="h-4 w-4" data-id="element-183" data-mp="2632td3v9c928" />
            Watch again
          </button>
          <button type="button" onClick={onExplore} className="h-11 rounded-full border border-white/[0.12] bg-white/[0.04] px-5 text-[14px] font-medium text-[#EDEEF2] transition-colors hover:bg-white/[0.08]" data-id="element-184" data-mp="21c2zk7hfq73y">
            Explore on your own
          </button>
        </div>
        <div className="mt-8 text-[11px] font-medium uppercase tracking-[0.08em] text-[#5D6272]" data-id="element-185" data-mp="2p1ow0n6fa889">
          Jump to a chapter
        </div>
        <div className="mt-2 flex flex-wrap justify-center gap-1.5" data-id="element-186" data-mp="2kxpkyk3ww1ma">
          {CHAPTERS.map((chapter, c) => <button key={chapter.title} type="button" onClick={() => onChapter(c)} className="flex h-8 items-center gap-1.5 rounded-full border border-white/[0.08] bg-white/[0.03] px-3 text-[12px] text-[#9A9FB0] transition-colors hover:bg-white/[0.07] hover:text-[#EDEEF2]" data-id="element-187" data-mp="up7gy2vqmeep" data-mpi={c}>
              {c > 0 && <span className="font-mono text-[11px] text-[#5D6272]" data-id="element-188" data-mp="2znxfumxp4zbs">{c}</span>}
              {chapter.short}
            </button>)}
        </div>
      </div>
    </div>;
}